import { CHART_IDS } from '../charts/chartIds'

const FAST_PREVIEW_CONFIG = {
  [CHART_IDS.POINT_MAP]: {
    mode: 'canvas',
    previewSampleRows: 8000,
    message:
      'Large dataset detected. Showing a faster sampled preview for responsiveness. Export still uses the full dataset.',
  },
  [CHART_IDS.BEESWARM]: {
    mode: 'canvas',
    previewSampleRows: 3000,
    message:
      'Large dataset detected. Showing a faster sampled preview for responsiveness. Export still uses the full dataset.',
  },
  [CHART_IDS.LINE_CHART]: {
    mode: 'svg',
    previewSampleRows: 8000,
    message:
      'Large dataset detected. Showing a sampled preview for responsiveness. Export still uses the full dataset, so aggregated totals may differ slightly in preview.',
  },
  [CHART_IDS.BAR_CHART]: {
    mode: 'svg',
    previewSampleRows: 8000,
    message:
      'Large dataset detected. Showing a sampled preview for responsiveness. Export still uses the full dataset, so aggregated totals may differ slightly in preview.',
  },
}

export const FAST_PREVIEW_ROW_THRESHOLD = 10000

export function getPreviewRendererMode(chart, rowCount) {
  const chartId = chart?.metadata?.id || ''
  const config = FAST_PREVIEW_CONFIG[chartId]
  const isLarge = Number(rowCount) > FAST_PREVIEW_ROW_THRESHOLD

  if (!config || !isLarge) {
    return {
      mode: 'svg',
      message: null,
      previewSampleRows: null,
      previewSampled: false,
    }
  }

  return {
    mode: config.mode,
    message: config.message,
    previewSampleRows: config.previewSampleRows,
    previewSampled: Number(rowCount) > config.previewSampleRows,
  }
}
